export default __webpack_public_path__ + "static/media/logo.36024643.svg";